import { render } from "./editComponent.vue?vue&type=template&id=1c62e8f3&scoped=true"
import script from "./editComponent.vue?vue&type=script&lang=js"
export * from "./editComponent.vue?vue&type=script&lang=js"

import "./editComponent.vue?vue&type=style&index=0&id=1c62e8f3&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c62e8f3"]])

export default __exports__